import { useEffect } from 'react';
import { useLocation, useMatches } from 'react-router';
import { useTelemetry } from './useTelemetry';
import { CREATE_PARAM } from 'Routes';

export const usePageTracking = () => {
  const { pathname } = useLocation();
  const matches = useMatches();
  const { trackPageView } = useTelemetry();

  useEffect(() => {
    let template = pathname;
    const leafMatch = matches[matches.length - 1];
    const params = leafMatch?.params;

    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value && value !== CREATE_PARAM) {
          template = template.replace(value, `:${key}`);
        }
      });
    }

    trackPageView(template);
  }, [pathname, trackPageView]);
};
